/* eslint-disable react-hooks/exhaustive-deps */

import React from 'react';

import { Grid } from 'semantic-ui-react';
import { matchPath } from 'react-router';
import { Icon } from 'iovisit-theme/components';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers';
import { UniversalLink } from '@plone/volto/components';
import { VariationWrapper, ImageListing } from 'iovisit-theme/components';
import config from '@plone/volto/registry';

const LinkCardVariation = (data) => {
  const { items, isEditMode } = data;

  return (
    <VariationWrapper {...data} variation="link-card">
      <Grid stackable>
        {items.map((item, index) => {
          let url = item.getURL || item['@id'] || null;

          const isBlacklisted =
            (config.settings.externalRoutes ?? []).find((route) =>
              matchPath(flattenToAppURL(url), route.match),
            )?.length > 0;
          const isExternal = !isInternalURL(url) || isBlacklisted;

          return (
            <Grid.Column
              tablet={12}
              computer={6}
              widescreen={6}
              largeScreen={6}
              key={index}
            >
              <div className="card-wrapper">
                <figure>
                  <ImageListing item={item} />
                </figure>
                <div className="card-body">
                  <div className="card-title">
                    <UniversalLink
                      item={!isEditMode ? item : null}
                      href={isEditMode ? '#' : null}
                    >
                      {item.title}{' '}
                      {isExternal && (
                        <Icon
                          prefix="fas"
                          icon="external-link-alt"
                          className="icon"
                          size="xs"
                        />
                      )}
                    </UniversalLink>
                  </div>
                </div>
              </div>
            </Grid.Column>
          );
        })}
      </Grid>
    </VariationWrapper>
  );
};

export default LinkCardVariation;
